let splashes = document.querySelectorAll(".splash");

const states = {
    onceEnded: false,
};

function disableScroll(event) {
    event.preventDefault();
}

function splash() {
    document.body.classList.remove("splashed");
    splashes.forEach((splash) => {
        splash.classList.remove("splashed");
    });
    window.scrollTo(0, 0);
    noscroll();

    splashes.forEach((splash) => {
        splash.classList.add("splash-is-ready");
    });

    const startTime = performance.now();
    const timerElm = document.querySelector(".Splash__logo .count");
    const animateDur = 3000;
    let canAnimate = true;

    const animateTime = () => {
        timerElm.innerHTML = Math.round(
            ((performance.now() - startTime) / animateDur) * 100
        );
        if (canAnimate) {
            requestAnimationFrame(animateTime);
        }
    };

    animateTime();

    setTimeout(() => {
        canAnimate = false;
        splashes.forEach((splash) => {
            splash.classList.add("splash-is-on");
        });
        setTimeout(() => {
            endSplash();
        }, 2000);
    }, animateDur);

    sessionStorage.setItem("splashed", true);
}

// windowが完全にロードされたらresolve(true)を返す関数
const isWindowLoaded = () => {
    return new Promise((resolve) => {
        if (document.readyState === "complete") {
            // ページがすでにロードされている場合はすぐにresolve
            resolve(true);
        } else {
            // ページがまだロードされていない場合は、loadイベントの完了を待つ
            window.addEventListener("load", () => resolve(true));
        }
    });
};

export const splashInit = () => {
    if (document.body.classList.contains("home")) {
        splashes = document.querySelectorAll(".splash");

        if (!sessionStorage.getItem("splashed")) {
            isWindowLoaded().then(() => {
                splash();
            });
        } else {
            document.body.classList.add("splashed");
            splashes.forEach((splash) => {
                splash.classList.add("splashed");
            });
        }
    }
    return () => {};
};

function noscroll() {
    document.addEventListener("touchmove", disableScroll, {
        passive: false,
    });
    document.addEventListener("mousewheel", disableScroll, {
        passive: false,
    });
}

export function endSplash() {
    states.onceEnded = true;
    document.removeEventListener("touchmove", disableScroll, {
        passive: false,
    });
    document.removeEventListener("mousewheel", disableScroll, {
        passive: false,
    });
    document.body.classList.add("splashed");
    splashes.forEach((splash) => {
        splash.classList.add("splashed");
    });
    setTimeout(() => {
        splashes.forEach((splash) => {
            splash.classList.remove("splash-is-ready");
            splash.classList.remove("splash-is-on");
        });
    }, 1500);
}

window.splashInit = () => {
    setTimeout(() => {
        window.scrollTo(0, 0);
        splash();
    }, 300);
};
